import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import { AudioVideoPlayer, Image } from "components";
import { useAnnotationPainter, useAnnotationsHandler, useMaterialSpecs } from "pages/MaterialSpecs/hooks";
import { DrawLayer } from "react-shape-editor";
import { VideoShapeEditor } from "./VideoShapeEditor.styled";
import { useSelector } from "react-redux";
import { getMaterialDetailsById } from "store/features/materialSpecs/specs";
import { API } from "api";
import { useAdMaterialVisual } from "hooks/api/useAdMaterialVisual";

interface AudioVideoPreview {
    path: string;
    width: number;
    height: number;
    isAudio?: boolean;
}

export const AudioVideoPreview = ({ path, width, height, isAudio = false }: AudioVideoPreview) => {
    const { showAnnotations, selectedAnnotation, isDrawingMode } = useAnnotationsHandler();
    const { drawHandler, shapes, addShapeHandler } = useAnnotationPainter();
    const [playedTimeInSeconds, setPlayedTimeInSeconds] = useState<number>(0);
    const [seekToSecond, setSeekToSecond] = useState<number>();
    const { selectedMaterialSpecId, selectedMaterialId, isVisualVisible, isPrinted } = useMaterialSpecs();
    const materialDetails = useSelector(getMaterialDetailsById(selectedMaterialSpecId, selectedMaterialId));
    const visualAsset = useAdMaterialVisual(isPrinted, selectedMaterialSpecId, selectedMaterialId);

    useEffect(() => {
        if (selectedAnnotation && selectedAnnotation.timeStampSeconds !== undefined) {
            setPlayedTimeInSeconds(selectedAnnotation.timeStampSeconds);
            setSeekToSecond(selectedAnnotation.timeStampSeconds);
        }
    }, [selectedAnnotation]);

    const getImageSource = () => {
        const dummyAudiowave = `${process.env.PUBLIC_URL}/dummyAudiowave.png`;

        if (isVisualVisible && visualAsset?.bigPreview?.url) {
            return `${API.serverUrl}${visualAsset.bigPreview.url}`;
        }

        if (materialDetails?.materialBigPreview?.url) {
            return `${API.serverUrl}${materialDetails.materialBigPreview.url}`;
        }

        return dummyAudiowave;
    };

    return (
        <Box display="flex" justifyContent="center" alignItems="center" flex={1}>
            <Box position="relative">
                {isAudio && (
                    <Box position="relative">
                        <Image src={getImageSource()} alt="audiowave" />
                    </Box>
                )}

                <AudioVideoPlayer
                    path={path}
                    width={width}
                    height={height}
                    isAudio={isAudio}
                    seekToSecond={seekToSecond}
                    onProgressCallback={(playedSeconds) => setPlayedTimeInSeconds(playedSeconds)}
                />
                {showAnnotations && (
                    <VideoShapeEditor vectorWidth={width} vectorHeight={height} scale={1}>
                        <DrawLayer
                            onDrawStart={({ startCorner }) => {
                                if (isDrawingMode) {
                                    setSeekToSecond(playedTimeInSeconds);
                                }
                                drawHandler({ ...startCorner, timeStampSeconds: playedTimeInSeconds });
                            }}
                            onAddShape={(rect) => addShapeHandler({ ...rect, timeStampSeconds: playedTimeInSeconds })}
                        />

                        {isAudio
                            ? shapes
                            : shapes.map((shape) =>
                                  shape &&
                                  Math.floor(playedTimeInSeconds) ===
                                      Math.floor(shape.props.extraShapeProps.timeStampSeconds)
                                      ? shape
                                      : null
                              )}
                    </VideoShapeEditor>
                )}
            </Box>
        </Box>
    );
};
